// RECURSOS DO PORTAL DO BANCO — a lista que a permissao do operador usa.
//
// Vivia DUAS VEZES: `apps/web/src/lib/banco-perms.ts` e
// `apps/api/src/modules/portal-banco/cadastros.ts`, com os mesmos presets e a
// mesma `detectarBancoPreset` copiados linha a linha. Enquanto as permissoes
// eram decorativas — o unico portao do portal era `role === "banco"` — divergir
// custava no maximo um rotulo errado na tela.
//
// A partir do momento em que o servidor CONFERE a permissao, divergir vira
// falha de autorizacao: a web esconderia um item de menu que a API libera, ou o
// contrario. Por isso a lista desce para a folha da arvore (@atlas/types) e os
// dois lados passam a ler a MESMA — e' o mesmo movimento que
// `prefeitura-recursos.ts` fez pela feature 009, e pelo mesmo motivo.
//
// Aqui fica so' o vocabulario. Quem le o JWT e decide o menu continua na web;
// quem barra a rota continua na API.
/** Recursos agrupados por categoria. Espelha o menu em
 *  `apps/web/src/routes/banco/nav.ts`. */
export const BANCO_RESOURCE_GROUPS = [
    {
        titulo: "Geral",
        recursos: [
            { key: "visao-geral", label: "Visao geral", descricao: "Tela de entrada: KPIs do credito, ou a visao do mes dos beneficios", escopo: "comum" },
            { key: "conta", label: "Minha conta", descricao: "Self-service (senha, 2FA)", escopo: "comum" },
        ],
    },
    // #312: o portal da consignataria que nao e' banco. Na tela dela a palavra e'
    // "beneficio"; no codigo, consignacao facultativa.
    {
        titulo: "Beneficios",
        recursos: [
            { key: "beneficios", label: "Beneficios", descricao: "Ver os beneficios descontados em folha", escopo: "beneficios" },
            { key: "beneficios-operar", label: "Operar beneficios", descricao: "Incluir, alterar valor e encerrar", escopo: "beneficios" },
            // RESPONDER: encerrar e atender, ou recusar. Ver a fila basta `beneficios`.
            { key: "solicitacoes", label: "Responder pedidos de cancelamento", descricao: "Encerrar e atender, ou recusar, os pedidos dos servidores", escopo: "beneficios" },
        ],
    },
    {
        titulo: "Propostas",
        recursos: [
            { key: "propostas", label: "Propostas (todas)", escopo: "credito" },
            { key: "emprestimo", label: "Emprestimo", escopo: "credito" },
            { key: "cartao", label: "Cartao", escopo: "credito" },
            { key: "cartao_beneficio", label: "Cartao beneficio", escopo: "credito" },
            { key: "portabilidade", label: "Portabilidade", escopo: "credito" },
            // Fora dos presets: o operador com "propostas" ja' alcanca o refinanciamento
            // (as rotas aceitam as duas chaves), e incluir aqui mudaria o preset
            // detectado de todo operador ja' cadastrado.
            { key: "refinanciamento", label: "Refinanciamento", descricao: "Pedidos e ofertas de refin", escopo: "credito" },
        ],
    },
    {
        titulo: "Operacao",
        recursos: [
            { key: "margem-contratacao", label: "Margem / Contratacao (averbar)", descricao: "Consulta e averbacao pela ficha", escopo: "credito" },
            // LEITURA da margem, sem averbar. Existe porque `margem-contratacao` junta
            // as duas coisas: quem so' precisa ver a margem do servidor (atendimento,
            // conferencia) levava junto a averbacao direta pela ficha. As rotas de
            // leitura aceitam qualquer uma das duas chaves; a de averbar, so' a antiga.
            { key: "margem-consulta", label: "Margem (somente consulta)", descricao: "Busca e ficha do servidor, sem averbar", escopo: "credito" },
            { key: "carteira", label: "Meus contratos", escopo: "credito" },
            { key: "falhas", label: "Falhas em folha", escopo: "credito" },
            { key: "convenios", label: "Convenios (leitura)", escopo: "credito" },
            { key: "ofertas", label: "Ofertas (marketing)", escopo: "credito" },
        ],
    },
    {
        titulo: "Troca de arquivos",
        recursos: [
            { key: "retornos", label: "Troca de arquivos", descricao: "Download dos retornos gerados para a consignataria", escopo: "comum" },
            // ESCRITA (o credor sobe o arquivo mensal dele): fora dos presets de
            // credito, que so' leem; dentro do preset `operadora`, porque mandar o
            // arquivo e' o dia a dia da consignataria de servicos.
            { key: "arquivos-envio", label: "Envio do arquivo mensal", descricao: "Enviar o arquivo da consignatária aos órgãos vinculados", escopo: "comum" },
        ],
    },
    {
        titulo: "Financeiro / relatorios",
        recursos: [
            { key: "bate-carteira", label: "Bate de carteira", escopo: "credito" },
            { key: "relatorios", label: "Relatorios (menu)", escopo: "credito" },
            // Relatorio de CONTRATOS de credito. O nome colide com consignacao
            // facultativa (beneficios); renomear exige migrar permissoes gravadas —
            // item 35 do PENDENCIAS.md.
            { key: "consignacoes", label: "Consignacoes", escopo: "credito" },
            { key: "gerador", label: "Gerador", escopo: "credito" },
            { key: "faturamento", label: "Faturamento (comissão)", descricao: "Comissão sobre contratos. Não é uso da API.", escopo: "credito" },
        ],
    },
    {
        titulo: "Cadastros",
        recursos: [
            { key: "cadastros", label: "Cadastros (menu)", escopo: "comum" },
            { key: "tabela-emprestimos", label: "Tabela de emprestimos", escopo: "credito" },
            // Fora dos presets: e' estrutura do proprio banco (como `usuarios`), nao
            // operacao do dia. A LISTA tambem responde a quem tem `usuarios`, porque o
            // formulario do operador precisa das opcoes.
            { key: "sub-organizacoes", label: "Sub organizacoes", escopo: "comum" },
            { key: "usuarios", label: "Operadores (CRUD)", escopo: "comum" },
            // Fora de todo preset de proposito: token de API e' acesso PROGRAMATICO
            // ao portal, e concede-lo por atalho ("é so' mais uma caixa") daria a um
            // operador de leitura uma credencial que nao expira com a sessao dele.
            // So' entra por marcacao explicita, ou via wildcard do admin. Comum:
            // quem so' opera beneficios tambem integra pela API.
            { key: "api", label: "API e documentacao", descricao: "Tokens de integracao", escopo: "comum" },
        ],
    },
];
export const BANCO_TODAS_PERMISSOES = BANCO_RESOURCE_GROUPS.flatMap((g) => g.recursos.map((r) => r.key));
export const BANCO_PRESETS = {
    admin: ["*"],
    operador: [
        "visao-geral",
        "propostas",
        "emprestimo",
        "cartao",
        "cartao_beneficio",
        "portabilidade",
        "ofertas",
        "margem-contratacao",
        "carteira",
        "falhas",
        "convenios",
        "conta",
    ],
    consulta: [
        "visao-geral",
        "propostas",
        "emprestimo",
        "cartao",
        "cartao_beneficio",
        "portabilidade",
        "carteira",
        "falhas",
        "convenios",
        "conta",
    ],
    // Consulta de margem e NADA mais: sem carteira (averbar/reservar/CCB), sem
    // propostas, sem cadastros. `visao-geral` e' a tela de entrada apos o login;
    // `conta` e' para o operador trocar a propria senha; `convenios` (so' GET)
    // alimenta o seletor de convenio do layout — sem ele o operador ficaria preso
    // no convenio padrao e nao consultaria a margem nos demais orgaos do banco.
    consulta_margem: ["visao-geral", "margem-consulta", "convenios", "conta"],
    relatorios: [
        "visao-geral",
        "relatorios",
        "consignacoes",
        "gerador",
        "faturamento",
        "bate-carteira",
        "retornos",
        "conta",
    ],
    // #314: a consignataria de servicos. Ve e opera os beneficios, atende os
    // pedidos de cancelamento, troca arquivos (inclusive ENVIA o mensal). Sem
    // `usuarios` nem `api`, como todo preset que nao e' o admin.
    operadora: [
        "visao-geral",
        "beneficios",
        "beneficios-operar",
        "solicitacoes",
        "retornos",
        "arquivos-envio",
        "conta",
    ],
    // Atendimento/conferencia: ve beneficios e a fila de pedidos (pela
    // permissao `beneficios`), baixa retornos; nao encerra, nao responde pedido,
    // nao inclui, nao envia arquivo. Sem `solicitacoes`: responder ao pedido e'
    // encerrar o beneficio, e consulta nao encerra (#318, decisao de 14/10/2026).
    operadora_consulta: ["visao-geral", "beneficios", "retornos", "conta"],
    personalizado: [],
};
/** Escopos que cada modo do portal enxerga. */
const ESCOPOS_DO_MODO = {
    credito: ["credito", "comum"],
    operadora: ["beneficios", "comum"],
    ambos: ["beneficios", "credito", "comum"],
};
/** O modo enxerga este escopo? Ausente/nulo e' `credito` — o credor anterior a #313. */
export function bancoEscopoNoModo(escopo, modo) {
    return ESCOPOS_DO_MODO[modo ?? "credito"].includes(escopo);
}
const ESCOPO_DO_RECURSO = new Map(BANCO_RESOURCE_GROUPS.flatMap((g) => g.recursos.map((r) => [r.key, r.escopo])));
/** O recurso existe no modo do credor. Chave desconhecida nao existe em modo nenhum. */
export function bancoRecursoNoModo(key, modo) {
    const escopo = ESCOPO_DO_RECURSO.get(key);
    return escopo != null && bancoEscopoNoModo(escopo, modo);
}
/** Os grupos de recursos que o modo enxerga, cada um so' com os recursos dele.
 *  Grupo que fica vazio some. E' o que a tela de operadores oferece. */
export function bancoGruposDoModo(modo) {
    return BANCO_RESOURCE_GROUPS.map((g) => ({
        ...g,
        recursos: g.recursos.filter((r) => bancoEscopoNoModo(r.escopo, modo)),
    })).filter((g) => g.recursos.length > 0);
}
/** Presets oferecidos a cada modo. `admin` e `personalizado` valem para todos. */
const PRESETS_DO_MODO = {
    credito: ["admin", "operador", "consulta", "consulta_margem", "relatorios", "personalizado"],
    operadora: ["admin", "operadora", "operadora_consulta", "personalizado"],
    ambos: ["admin", "operador", "consulta", "consulta_margem", "relatorios", "operadora", "operadora_consulta", "personalizado"],
};
export function bancoPresetsDoModo(modo) {
    return PRESETS_DO_MODO[modo ?? "credito"];
}
/** Presets NATIVOS (os de cima). Serve para recusar que um preset salvo pelo
 *  banco nasca com uma chave que colida com eles — ver `PREFIXO_PRESET_CUSTOM`. */
export const BANCO_PRESET_KEYS = Object.keys(BANCO_PRESETS);
// A chave de preset customizado vive em `preset-custom.ts` desde que a
// organizacao passou a precisar da MESMA regra: nao e' regra de banco, e' a
// forma da chave. Quem consome importa de `@atlas/types`, que exporta os dois —
// reexportar aqui criaria nome duplicado no barrel.
/** Qual preset nativo corresponde a esta lista de permissoes. `personalizado`
 *  quando nao bate com nenhum — e' rotulo de UI, nao fonte de autorizacao. */
export function detectarBancoPreset(permissoes) {
    const set = new Set(permissoes);
    for (const [nome, keys] of Object.entries(BANCO_PRESETS)) {
        if (nome === "personalizado")
            continue;
        if (keys.length !== set.size)
            continue;
        if (keys.every((k) => set.has(k)))
            return nome;
    }
    return "personalizado";
}
/**
 * A permissao cobre este recurso?
 *
 * AUSENTE (`undefined`/`null`) = login-MASTER do banco (o `bancos.loginEmail`),
 * que ve tudo. Essa retrocompatibilidade e' deliberada: sem ela, ligar o portao
 * derrubaria o acesso de todo banco ja cadastrado, cujo JWT em circulacao nao
 * tem a claim nova.
 *
 * VAZIA (`[]`) = operador SEM permissao nenhuma, e nao cobre nada.
 *
 * A distincao entre os dois e' o ponto desta funcao, e nao e' teorica: o preset
 * `personalizado` e' `[]` por definicao (ponto de partida vazio, marque caixa a
 * caixa). Tratar vazio como "ve tudo" — que e' o que `permissaoCobre` da
 * organizacao faz — daria acesso TOTAL ao operador criado com o preset que
 * promete o contrario, incluindo o CRUD de operadores. Um teste deste repo
 * existe so' para travar isto (`operador-permissao.test.ts`).
 *
 * Por isso o resolver do login preenche a claim SEMPRE, nem que seja com `[]`:
 * e' o que garante que operador nunca caia no caminho do master.
 */
export function bancoPermissaoCobre(permissoes, key) {
    if (permissoes == null)
        return true;
    if (permissoes.includes("*"))
        return true;
    return permissoes.includes(key);
}
//# sourceMappingURL=banco-recursos.js.map